import { createSignal } from 'solid-js'
import { createStore } from 'solid-js/store'
import type { Layer } from '../audio/engine'
import type { AppMode, Selection, TransformMode, ViewMode } from '../viewport/types'

export type UiSelection = Selection | { kind: 'room' }

export interface Toast {
  id: number
  text: string
  tone: 'info' | 'error'
}

export type AudioStatus = 'off' | 'starting' | 'on' | 'error'

export function createUiState() {
  const [ui, setUi] = createStore({
    mode: 'edit' as AppMode,
    selection: { kind: 'room' } as UiSelection,
    transformMode: 'translate' as TransformMode,
    view: 'perspective' as ViewMode,
    cutaway: true,
    showGrid: true,
    debugOverlay: false,
    layerSolo: null as Layer | null,
    audioStatus: 'off' as AudioStatus,
    audioError: '',
    level: 0,
    /** Last source used for the click test. */
    clickSource: null as string | null,
    /** Explore walking speed in m/s (changes with the mouse wheel). */
    walkSpeed: 0,
  })
  const [toasts, setToasts] = createSignal<Toast[]>([])
  let nextToast = 1

  function toast(text: string, tone: Toast['tone'] = 'info') {
    const id = nextToast++
    setToasts((t) => [...t.slice(-3), { id, text, tone }])
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), tone === 'error' ? 6000 : 3200)
  }

  return { ui, setUi, toasts, toast }
}

export type UiState = ReturnType<typeof createUiState>
